// src/ApiClient/GetApi.js
import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../Utils/urls";

const useFetch = (url) => {
  console.log(url)
  const [apiData, setData] = useState(null); // <- null, not []
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!url) {
      // no url -> reset and don't call API
      setData(null);
      setLoading(false);
      return;
    }

    const header_config = {
      headers: {
        accessToken: localStorage.getItem("accessToken"),
      },
    };
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(BASE_URL + url, header_config);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [url]);

  const reFetch = async () => {
    if (!url) return;
    const header_config = {
      headers: {
        accessToken: localStorage.getItem("accessToken"),
      },
    };
    setLoading(true);
    try {
      const response = await axios.get(BASE_URL + url, header_config);
      console.log("reFetch response:", response);
      setData(response.data);
    } catch (error) {
      console.error("Error re-fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return { apiData, loading, reFetch };
};

export default useFetch;
